module.exports = __webpack_public_path__ + "static/img/banner4.a716a25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/banner4.jpg
// module id = CzyQ
// module chunks = 1